import React from 'react'

const UploadIcon: React.FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 32V16M24 16L18 22M24 16L30 22" stroke="var(--qs-accent-muted)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 30C8 30 8 38 16 38H32C40 38 40 30 40 30" stroke="var(--qs-accent-muted)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 20C10 20 6 22 6 28" stroke="var(--qs-accent-faint)" strokeWidth="2" strokeLinecap="round" />
      <path d="M34 20C38 20 42 22 42 28" stroke="var(--qs-accent-faint)" strokeWidth="2" strokeLinecap="round" />
      <path d="M16 18C16 12 20 8 24 8C28 8 32 12 32 18" stroke="var(--qs-accent-faint)" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default UploadIcon
